import React, { Component } from 'react';
import { Tabs } from 'antd';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { interfaceActions } from '../../common/redux/actions';

import * as URLs from '../../common/constants/systemUrls';
// Контейнеры
import Documents from './Documents/containers/Documents/Documents';
import ContractSettings from './ContractSettings/containers/ContractSettings';
import { DocumentDrawer } from './components/DocumentDrawer';

const { TabPane } = Tabs;

const { setCaption } = interfaceActions;

function getLastPathSegment(path) {
  let segments = path.split('/');
  return segments[segments.length - 1];
}

class DocumentsCommon extends Component {
  componentDidMount() {
    this.props.setCaption({
      enabled: true,
      mainCaption: 'Документы',
      breadCrumbs: [
        // Путь для хлебных крошек
        { path: '/' + URLs.CONTROL_PANEL, breadcrumbName: 'Панель управления' },
        { path: '/' + URLs.VEHICLES, breadcrumbName: 'Документы' },
      ],
    });
  }

  onTabsChange = key => {
    let { match, history } = this.props;
    switch (key) {
      case 'documents_by_orders': {
        history.push(match.path + '/documents_by_orders');
        break;
      }
      case 'contract_settings': {
        history.push(match.path + '/contract_settings');
        break;
      }
      default:
        break;
    }
  };

  render() {
    let { match, location } = this.props;
    return (
      <div id="documents" className="basicForm">
        <DocumentDrawer />
        <Tabs
          type="card"
          activeKey={getLastPathSegment(location.pathname)}
          onTabClick={this.onTabsChange}
        >
          <TabPane tab="Документы по заказам" key="documents_by_orders">
            <Route
              path={match.path + '/documents_by_orders'}
              render={props => <Documents {...props} />}
            />
          </TabPane>

          <TabPane tab="Настройка договора" key="contract_settings">
            <Route
              path={match.path + '/contract_settings'}
              render={props => <ContractSettings {...props} />}
            />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default connect(state => ({}), {
  setCaption,
})(DocumentsCommon);
